import { QueryState } from 'common/enums';
import { Nullable } from 'common/utils/Nullable';

export interface IDeleteNotificationContactState {
  state: QueryState;
  error: Nullable<string>;
  accessToken: string | undefined;
}

export const DeleteNotificationContactEmptyState: IDeleteNotificationContactState = {
  state: QueryState.UNDEFINED,
  error: null,
  accessToken: undefined
};
